import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  InputAdornment,
  InputLabel,
  Stack,
  TextField,
} from "@mui/material";
import "./Login.scss";
import { useEffect, useState } from "react";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import toaster from "../../../../utility/toaster/toaster";
import Carousel from "../../../components/carousel/carousal";

export default function Login() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  // const [app_id, setApp_id] = useState("")
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  let credentials = { email, password };

  const [index, setIndex] = useState(0);
  const [applications, setApplications] = useState([]);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const [clearedAppData, setClearedAppData] = useState(false); // Track if clearAllAppData() is executed

  //Logout Functionality
  function clearAllAppData() {
    if (!clearedAppData) {
      // Clear cookies
      document.cookie.split(";").forEach((cookie) => {
        const name = cookie.split("=")[0].trim();
        let domain = "";

        if (
          process.env.REACT_APP_ENV === "production" ||
          process.env.REACT_APP_ENV === "test"
        ) {
          // Production & Test environment
          domain = "; domain=.pharmaaceapps.com";
        }

        document.cookie =
          name + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/" + domain;
      });

      localStorage.clear();
      sessionStorage.clear();

      // Clear IndexedDB
      indexedDB.databases().then((databases) => {
        databases.forEach((db) => {
          indexedDB.deleteDatabase(db.name);
        });
      });

      setClearedAppData(true); // Ensure this runs only once
    }
  }
  // Function to check if user is authenticated and redirect accordingly
  const checkAuthentication = async () => {
    try {
      console.log(
        `${process.env.REACT_APP_BACKEND_URL_LOGIN_APP}/auth/check-token`
      );
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL_LOGIN_APP}/auth/check-token`,
        {
          method: "GET",
          credentials: "include", // Include cookies in the request
        }
      );

      if (response.ok) {
        // Redirect to the login page after successful logout
        console.error("auth success navigation to app page login app frn");
        navigate("/applications");
      } else {
        clearAllAppData();
        console.error("authentication failed inside login app frn");
        // Handle authentication error if needed
      }
    } catch (error) {
      clearAllAppData();
      console.error("Error during authentication:", error);
      // Handle network or fetch errors
    }
  };

  // Call the function when the login page is loaded
  //window.onload = checkAuthentication;

  const handleSubmit = (event) => {
    event.preventDefault();

    const config = {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": `${process.env.REACT_APP_BACKEND_URL_LOGIN_APP}`,
        "Access-Control-Allow-Credentials": "true",
      },
      withCredentials: true,
    };

    axios
      .post(
        `${process.env.REACT_APP_BACKEND_URL_LOGIN_APP}/auth/login`,
        credentials,
        config
      )
      .then((response) => {
        toaster("success", `Login Successful`);
        setTimeout(() => {
          const params = new URLSearchParams(window.location.search);
          const redirectUrl = params.get("redirect");

          if (redirectUrl) {
            // Go back to original app page
            window.location.href = redirectUrl;
          } else {
            // Default login app route
            navigate("/applications");
          }
        }, 1500);
      })
      .catch((error) => {
        console.error("Login error", error);
        toaster("error", error.response?.data?.message);
      });
  };

  useEffect(() => {
    checkAuthentication();
    const intervalId = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % applications?.length);
    }, 3000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return (
    <Grid className="login-main-container">
      <Grid className="login-main-inner">
        <Grid className="login-main-left">
          <Grid className="login-main-left-inner">
            <Grid className="login-main-left-head">
              <h4>
                Your One-Stop Solution for{" "}
                <strong>all PharmaACE Internal Apps</strong>
              </h4>
              <p>PACEAPPS</p>
            </Grid>
            <Grid className="login-main-left-body">
              <Grid className="carousel-container">
                <Carousel />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid className="login-main-right">
          <Grid className="login-main-right-inner">
            <Grid className="login-main-right-form-head">
              <h1>
                <span id="title-start">PACE</span>{" "}
                <span id="title-end">APPS</span>
              </h1>
            </Grid>
            <Grid className="login-main-right-form-body">
              <Grid className="login-form-wrapper">
                <form onSubmit={handleSubmit}>
                  <Stack spacing={5}>
                    <Grid className="form-heading">
                      <h2>Login</h2>
                      <p>Enter credentials to access allocated applications</p>
                    </Grid>

                    <Grid className="form-field">
                      <InputLabel
                        className="input-label"
                        htmlFor="email-form-control"
                        shrink={true}
                      ></InputLabel>
                      <TextField
                        // required
                        name="email"
                        value={email ?? ""}
                        id="email-form-control"
                        label="Email"
                        InputLabelProps={{ shrink: true }}
                        placeholder="Enter email"
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </Grid>

                    <Grid className="form-field">
                      <FormControl
                        id="password-form-control"
                        variant="outlined"
                      >
                        <TextField
                          className="password-input"
                          name="password"
                          label="Password"
                          InputLabelProps={{ shrink: true }}
                          placeholder="Enter password"
                          id="outlined-password-input"
                          value={password ?? ""}
                          onChange={(e) => setPassword(e.target.value)}
                          type={showPassword ? "text" : "password"}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <span
                                  className="toggle-eye"
                                  onClick={togglePasswordVisibility}
                                  style={{ cursor: "pointer" }}
                                >
                                  {showPassword ? (
                                    <Visibility />
                                  ) : (
                                    <VisibilityOff />
                                  )}
                                </span>
                              </InputAdornment>
                            ),
                          }}
                        />
                      </FormControl>
                      <Grid className="forgot-rememberMe">
                        <FormControlLabel
                          control={
                            <Checkbox
                              onChange={(e) => setRememberMe(!rememberMe)}
                            />
                          }
                          label="Remember me"
                        />
                        <span
                          className="forgot-text"
                          onClick={() => navigate("/forgot-password")}
                          style={{ textDecoration: "underline" }}
                        >
                          Forgot password?
                        </span>
                      </Grid>
                    </Grid>
                    {/* <Grid className="form-field">
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select-label">Applications</InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={app_id}
                            label="Applications"
                            onChange={handleOptionChange}>
                            <MenuItem value={1}>SoW Tracker</MenuItem>
                            <MenuItem value={2}>TPA Tracker</MenuItem>
                            <MenuItem value={3}>Invoice Tracker</MenuItem>
                            <MenuItem value={4}>VISA Tracker</MenuItem>
                            <MenuItem value={5}>Offer Letter Generator</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid> */}
                    <Grid className="form-button">
                      <Button
                        type="submit"
                        variant="contained"
                        size="large"
                        disabled={!email || !password}
                      >
                        Login
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="14"
                          height="8"
                          viewBox="0 0 18 12"
                          fill="none"
                        >
                          <path
                            d="M9.67399 11.748C9.57332 11.6684 9.49345 11.5738 9.43895 11.4696C9.38445 11.3655 9.3564 11.2538 9.3564 11.141C9.3564 11.0282 9.38445 10.9166 9.43895 10.8124C9.49345 10.7083 9.57332 10.6137 9.67399 10.534L14.3072 6.85729L1.07979 6.85729C0.793409 6.85729 0.51876 6.76701 0.316261 6.60631C0.113762 6.44562 -2.7222e-07 6.22767 -2.62286e-07 6.0004C-2.52352e-07 5.77314 0.113762 5.55519 0.316261 5.39449C0.51876 5.2338 0.793409 5.14352 1.07979 5.14352L14.3072 5.14352L9.67399 1.46533C9.47114 1.30436 9.35718 1.08603 9.35718 0.858372C9.35718 0.630718 9.47114 0.412387 9.67399 0.251411C9.87684 0.0904352 10.152 -3.4065e-07 10.4388 -3.30509e-07C10.7257 -3.20368e-07 11.0008 0.0904353 11.2037 0.251411L17.6824 5.39273C17.7831 5.47234 17.8629 5.56693 17.9174 5.67109C17.9719 5.77524 18 5.88691 18 5.99969C18 6.11247 17.9719 6.22414 17.9174 6.3283C17.8629 6.43245 17.7831 6.52705 17.6824 6.60665L11.2037 11.748C11.1034 11.8279 10.9842 11.8912 10.8529 11.9345C10.7217 11.9777 10.581 12 10.4388 12C10.2967 12 10.156 11.9777 10.0248 11.9345C9.89351 11.8912 9.77431 11.8279 9.67399 11.748Z"
                            fill="white"
                          />
                        </svg>
                      </Button>
                      {/* <p>
                            No account?{" "}
                            <span onClick={() => navigate("/signup")}>
                              Signup
                            </span>
                          </p> */}
                    </Grid>
                  </Stack>
                </form>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
